/**
 * Класс для управления полями ввода участников команды
 */
class TeamMembersField {
  /**
   * @param {HTMLElement} container - Контейнер группы полей ввода
   */
  constructor(container) {
    /** @type {HTMLElement} */
    this.container = container;

    /** @type {HTMLElement} */
    this.rowTemplate = this.container.querySelector('.js-field-row');

    /** @type {HTMLElement} */
    this.addButton = this.container.querySelector('.js-add-row');

    this.init();
  }

  /**
   * Инициализирует компонент
   * @private
   */
  init() {
    // Обработчик для кнопки добавления
    this.addButton.addEventListener('click', () => this.addRow());

    // Инициализация существующих строк
    this.initializeExistingRows();
  }

  /**
   * Инициализирует уже существующие строки в DOM
   * @private
   */
  initializeExistingRows() {
    const existingRows = this.container.querySelectorAll('.js-field-row');
    existingRows.forEach((row) => {
      this.setupRowEventListeners(row);
    });
    // Обновляем все кнопки после инициализации
    this.updateAllDeleteButtons();
  }

  /**
   * Создает и добавляет новую строку ввода
   * @public
   */
  addRow() {
    // Клонируем шаблон строки
    const newRow = this.rowTemplate.cloneNode(true);
    const input = newRow.querySelector('input');

    if (input) {
      input.value = '';
    }

    // Добавляем новую строку перед кнопкой добавления
    this.addButton.parentNode.insertBefore(newRow, this.addButton);

    // Настраиваем обработчики для новой строки
    this.setupRowEventListeners(newRow);

    // Фокусируемся на новом поле ввода
    if (input) {
      input.focus();
    }

    // Обновляем все кнопки удаления после добавления новой строки
    this.updateAllDeleteButtons();
  }

  /**
   * Настраивает обработчики событий для строки ввода
   * @private
   * @param {HTMLElement} row - Элемент строки ввода
   */
  setupRowEventListeners(row) {
    const input = row.querySelector('input');
    const deleteButton = row.querySelector('.js-delete-row');

    if (input) {
      // Обработчик ввода текста для обновления кнопки удаления
      input.addEventListener('input', () => {
        this.updateAllDeleteButtons();
      });
    }

    if (deleteButton) {
      // Обработчик клика на кнопку удаления
      deleteButton.addEventListener('click', () => {
        this.removeRow(row);
      });
    }
  }

  /**
   * Обновляет состояние кнопки удаления для конкретной строки
   * @private
   * @param {HTMLElement} row - Элемент строки ввода
   */
  updateDeleteButtonForRow(row) {
    const deleteButton = row.querySelector('.js-delete-row');

    if (deleteButton) {
      const rows = this.container.querySelectorAll('.js-field-row');
      const totalRows = rows.length;

      // 1. Если всего одна строка - скрываем кнопку удаления (независимо от содержимого)
      // 2. Если строк больше одной - показываем кнопку удаления
      if (totalRows === 1) {
        deleteButton.classList.add('d-none');
      } else {
        deleteButton.classList.remove('d-none');
      }
    }
  }

  /**
   * Обновляет состояние всех кнопок удаления
   * @private
   */
  updateAllDeleteButtons() {
    const rows = this.container.querySelectorAll('.js-field-row');

    rows.forEach((row) => {
      this.updateDeleteButtonForRow(row);
    });
  }

  /**
   * Удаляет указанную строку ввода
   * @private
   * @param {HTMLElement} row - Элемент строки для удаления
   */
  removeRow(row) {
    row.remove();
    this.updateAllDeleteButtons();
  }

  /**
   * Получает массив участников команды из заполненных полей ввода
   * @public
   * @returns {string[]} Массив имен участников команды
   */
  getTeamMembers() {
    const members = [];
    const rows = this.container.querySelectorAll('.js-field-row');

    rows.forEach((row) => {
      const input = row.querySelector('input');
      if (input && input.value.trim()) {
        members.push(input.value.trim());
      }
    });

    return members;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const teamFields = document.querySelectorAll('.js-form-field-group');

  teamFields.forEach((field) => {
    new TeamMembersField(field);
  });
});
